const InfoItem = ({ title, children }) => {
  return (
    <>
      <span>{title}:</span>
      <span className="fw-bold me-1">{children || "تعریف نشده"}</span>
    </>
  );
};

export default InfoItem;
